<template>
  <w-dialog
    :show="visible"
    @close="handleClose"
    class="ent-info-form"
    title="加入企业"
    :wallclose="false"
    :wallStyle="{ zIndex: 2001 }"
    :box-style="{ width: '500px', zIndex: 2001 }"
    :bodyStyle="{ padding: '20px 24px 24px 24px' }"
    :footerStyle="{ padding: '24px', borderTop: 'none' }">
    <!-- 网易易盾 -->
    <div ref="captcha"></div>
    <div>
      <div class="ent-explain-text">
        通过管理员获取企业邀请码，加入您所在的企业，开启企业专属权益
      </div>
      <div class="join-ent-form">
        <w-form ref="ruleForm" :model="ruleForm" label-width="102px" :rules="rules">
          <w-form-item label="企业邀请码" prop="shareKey" style="margin-bottom: 24px;">
            <w-input size="small" v-model.trim="ruleForm.shareKey" placeholder="请输入企业邀请码" @input="handleInput"></w-input>
          </w-form-item>
          <w-form-item label="企业名称" style="margin-bottom: 24px;">
            <w-input size="small" readonly disabled :value="ruleForm.enterpriseName"></w-input>
          </w-form-item>
          <w-form-item label="手机号" prop="mobile" style="margin-bottom: 24px;">
            <w-input size="small" v-model.trim="ruleForm.mobile" placeholder="请输入手机号码" clearable></w-input>
          </w-form-item>
          <w-form-item label="验证码" prop="code" style="margin-bottom: 0;">
            <w-input style="width: 242px; margin-right: 8px;" size="small"
                     v-model.trim="ruleForm.code"
                     :disabled="!/^1[3456789]{1}\d{9}$/.test(ruleForm.mobile)"
                     placeholder="6位验证码"
                     clearable></w-input>
            <w-button style="width: 100px; padding-left: 0; padding-right: 0;"
                      type="minor"
                      :disabled="!/^1[3456789]{1}\d{9}$/.test(ruleForm.mobile) || ruleForm.timer !== 0"
                      @click.prevent.stop>
              <Countdown :time="ruleForm.timer" @click="getVerification" @finish="ruleForm.timer = 0" />
            </w-button>
          </w-form-item>
        </w-form>
      </div>
    </div>
    <div slot="footer" class="text-align-right">
      <w-button size="small" type="minor" @click="handleClose()">取消</w-button>
      <w-button size="small" type="primary" @click="handleSubmit()"
                :disabled="!(ruleForm.shareKey && ruleForm.mobile && ruleForm.code && ruleForm.effective)">
        下一步
      </w-button>
    </div>
  </w-dialog>
</template>

<script>
import Countdown from '_c/common/countDown'
import LoginService from '@/assets/service/login'
import { invitationValid } from '@/assets/service/invitation'
import { aes, appId, captchaId } from '@/assets/utils/CommonUtil'
let captchaIns

export default {
  name: 'EntInfoForm',
  components: {
    Countdown
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible: {
      handler () {
        Object.assign(this.ruleForm, {
          shareKey: '',
          effective: false,
          enterpriseName: '',
          mobile: '',
          code: '',
          timer: 0
        })
        this.$nextTick(() => {
          this.$refs.ruleForm && this.$refs.ruleForm.resetFields()
        })
      },
      immediate: false
    }
  },
  data () {
    // 请输入手机号码
    const validateMobile = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入手机号码'))
      } else if (!/^1[3456789]{1}\d{9}$/.test(value)) {
        return callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    // 请输入验证码
    const validateCode = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    // 请输入邀请码
    const validateShareKey = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('企业邀请码不能为空'))
      } else if (value.length !== 7) {
        return callback(new Error('企业邀请码为7位字符'))
      } else {
        this.sentLog(100117103)
        invitationValid({ shareKey: value }).then(res => {
          const {code, data, message} = res
          const { effective = false, enterpriseName, enterpriseId } = data || {}
          Object.assign(this.ruleForm, {
            enterpriseName,
            effective,
            enterpriseId
          })
          if (code === 200 && effective) {
            callback()
          } else {
            callback(message)
          }
        })
      }
    }
    return {
      ruleForm: {
        shareKey: '',
        effective: false,
        enterpriseName: '',
        mobile: '',
        code: '',
        timer: 0
      },
      rules: {
        shareKey: [
          {required: true, validator: validateShareKey, trigger: 'blur'}
        ],
        mobile: [
          {required: true, validator: validateMobile, trigger: 'blur'}
        ],
        code: [
          {required: true, validator: validateCode, trigger: 'blur'}
        ]
      }
    }
  },
  mounted () {
    this.initNECaptcha()
  },
  methods: {
    // 取消
    handleClose () {
      this.$emit('close')
    },
    // 输入邀请码
    handleInput (shareKey = '') {
      if (typeof shareKey !== 'string' || shareKey.length !== 7) {
        Object.assign(this.ruleForm, {
          enterpriseName: '',
          effective: false
        })
      }
    },
    // 调用网易易盾验证接口
    getVerification () {
      if (!/^1[3456789]{1}\d{9}$/.test(this.ruleForm.mobile) || this.ruleForm.timer > 0){
        return
      }
      captchaIns && captchaIns.verify()
    },
    // 1.2 网易易盾验证成功回调
    verifyCallback ({ captchaCode }) {
      captchaIns && captchaIns.refresh()
      const { mobile } = this.ruleForm
      const errMsg = '获取验证码失败'
      // 获取短信
      const t = Date.now()
      LoginService.getMobileCode({ appId, sign: aes(t, mobile), t }, { captchaCode, captchaId, mobile }).then(res => {
        if (res.code === 200) {
          this.ruleForm.timer = 60
        } else {
          this.$message.error(res.message || errMsg)
        }
      }).catch(() => {
        this.$message.error(errMsg)
      })
    },
    // 网易易盾初始化
    initNECaptcha () {
      let that = this
      window.initNECaptcha({
        element: this.$refs.captcha, // 验证码容器元素ID
        captchaId, // 由用户中心分配
        mode: 'bind',
        width: '320px',
        onVerify (err, data) {
          if (err) {
            console.log(err.message)
          } else if (data) { // 用户验证码验证成功后，进行实际的提交行为
            that.verifyCallback({captchaCode: data.validate, captchaId})
          }
        }
      }, instance => {
        // 初始化成功后得到验证实例instance，可以调用实例的方法
        captchaIns = instance
      }, err => {
        // 初始化失败后触发该函数，err对象描述当前错误信息
        console.log(err.message)
      })
    },
    // 提交
    handleSubmit () {
      this.sentLog(100117104)
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.validateUserInfo()
        }
      })
    },
    // 接口验证
    validateUserInfo () {
      this.$emit('submit', this.ruleForm)
    }
  }
}
</script>
